export const INIT_PLAYER = `
  query Init($token: String!, $gameCode: String!) {
  init(token: $token, gameCode: $gameCode) {
    status
    success
    message
    code
    data {
      gameCode
      gameMode
      balance
      playerId
      accessToken
      token
      language
      operator {
        operatorId
        brandId
        operatorName
        brandName
        currency
      }
      stakeControls {
        minimumStake
        maximumStake
        defaultStake
        presetBets
      }
      features {
        freebets
        buyBonus
        tournament
        jackpot
        missions
        chat
      }
    }
  }
}
`

export const PLAYER_SEEDS = `
  query Seeds {
    players {
      seeds {
        status
        success
        message
        code
        data {
          clientSeed
          hashedServerSeed
          hashedNextServerSeed
          nonce
        }
      }
    }
  }
`

export const PLAYER_BETS = `
  query Bets(
    $operatorId: String!
    $brandId: String
    $currency: String
    $playerId: String!
    $gameCode: String
    $transactionType: [String]
    $transactionSubType: [String]
    $transactionSourceType: [String]
    $status: [String]
    $page: Int
    $limit: Int
  ) {
    players {
      bets(
        operatorId: $operatorId
        brandId: $brandId
        currency: $currency
        playerId: $playerId
        gameCode: $gameCode
        transactionType: $transactionType
        transactionSubType: $transactionSubType
        transactionSourceType: $transactionSourceType
        status: $status
        page: $page
        limit: $limit
      ) {
        status
        success
        message
        code
        data {
          total
          bets {
            transactionId
            playerId
            operatorId
            brandId
            gameCode
            currency
            type
            subType
            source
            status
            result
            betAmount
            payout
            payoutMultiplier
            crashMultiplier
            cashoutAt
            createdAt
            freebetId
            freebetAmount
          }
        }
      }
    }
  }
`

export const PLAYER_BET_DETAILS = `
  query BetDetails($transactionId: String!) {
    players {
      betDetails(transactionId: $transactionId) {
        status
        success
        message
        code
        data {
          transactionId
          roundId
          betAmount
          payout
          payoutMultiplier
          crashMultiplier
          currency
          status
          createdAt
          clientSeed
          hashedServerSeed
          nonce
          hash
          seed
        }
      }
    }
  }
`

export const VERIFY_FAIRNESS = `
  query Verify($hash: String!, $seed: String!, $gameCode: String, $gameMode: String) {
    players {
      verifyFairness(hash: $hash, seed: $seed, gameCode: $gameCode, gameMode: $gameMode) {
        status
        success
        message
        code
        data {
          crashMultiplier
        }
      }
    }
  }
`

export const UPDATE_CLIENT_SEED = `
  mutation UpdateClientSeed($clientSeed: String!) {
    players {
      updateClientSeed(clientSeed: $clientSeed) {
        status
        success
        message
        code
        data {
          clientSeed
          hashedServerSeed
          nonce
          hashedNextServerSeed
        }
      }
    }
  }
`
